'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ramda = require('ramda');

var _conditionUtils = require('./conditionUtils');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var isNotProvided = function isNotProvided(val) {
  return val == null || val._isAbsent;
};

var OPERATIONS = {
  '==': function _(a, b) {
    return a === b;
  },
  '!=': function _(a, b) {
    return a !== b;
  },
  '<': function _(a, b) {
    return a < b;
  },
  '<=': function _(a, b) {
    return a <= b;
  },
  '>': function _(a, b) {
    return a > b;
  },
  '>=': function _(a, b) {
    return a >= b;
  },
  and: function and(a, b) {
    return Boolean(a && b);
  },
  or: function or(a, b) {
    return Boolean(a || b);
  },
  present: function present(a) {
    return Boolean((isNotProvided(a) ? '' : String(a)).trim());
  },
  blank: function blank(a) {
    return !Boolean((isNotProvided(a) ? '' : String(a)).trim());
  },
  in: function _in(item, array) {
    return array.includes(item);
  },
  nin: function nin(item, array) {
    return !array.includes(item);
  },
  regex: function regex(a, b) {
    return b.test(a);
  }
};

var getOperation = function getOperation(operator) {
  var validOperation = OPERATIONS[operator];
  if (validOperation) {
    return validOperation;
  }

  throw new Error('Invalid operator \'' + operator + '\'');
};

var warnOfAbsentValue = function warnOfAbsentValue(path, fieldProperty) {
  var joinedPath = [].concat(path).join('.');

  // console.error(`Cannot access "${fieldProperty}" of absent field queried with '${joinedPath}'`) // eslint-disable-line no-console
};
var absentValue = (0, _ramda.memoize)(function (path) {
  return {
    get value() {
      warnOfAbsentValue(path, 'value');
    },
    get editable() {
      warnOfAbsentValue(path, 'editable');
    },
    get readable() {
      warnOfAbsentValue(path, 'readable');
    },
    get required() {
      warnOfAbsentValue(path, 'required');
    },
    _isAbsent: true
  };
});

var evaluateCondition = function evaluateCondition(_ref, evaluateVar) {
  var _ref2 = _toArray(_ref),
      operator = _ref2[0],
      operands = _ref2.slice(1);

  return getOperation(operator).apply(undefined, _toConsumableArray((0, _conditionUtils.getOperands)(operator, operands).map(function (operand) {
    if ((0, _conditionUtils.isConditionalValue)(operand)) {
      return evaluateCondition(operand, evaluateVar);
    }

    if ((0, _conditionUtils.isValidOperand)(operand)) {
      if (operand.type === 'var') {
        var evaluatedVar = evaluateVar(operand.value);
        return evaluateVar == null ? absentValue(operand.value) : evaluatedVar;
      } else {
        return operand && (typeof operand === 'undefined' ? 'undefined' : _typeof(operand)) === 'object' ? operand.value : operand;
      }
    }

    throw new Error('Invalid format: ' + JSON.stringify(operand));
  })));
};

exports.default = evaluateCondition;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/evaluateCondition.js
// module id = 226
// module chunks = 0